import jsQR from "jsqr";

export function decodeQrImage(src: string): Promise<string | null> {
    return new Promise((resolve) => {
        const image = new Image();
        image.onload = () => {
            const canvas = document.createElement("canvas");
            canvas.width = image.naturalWidth;
            canvas.height = image.naturalHeight;
            const context = canvas.getContext("2d", {willReadFrequently: true});
            if (!context) {
                resolve(null);
                return;
            }
            context.drawImage(image, 0, 0);
            const pixels = context.getImageData(0, 0, canvas.width, canvas.height);
            const code = jsQR(pixels.data, pixels.width, pixels.height);
            resolve(code?.data || null);
        };
        image.onerror = () => resolve(null);
        image.src = src;
    });
}
